import posed from 'react-pose';

export const MenuPose = posed.nav({
  open: {
    opacity: 1,
    x: 0,
    transition: {
      default: { ease: 'linear', duration: 150 }
    }
  },
  closed: {
    opacity: 0,
    x: -280,
    transition: {
      default: { ease: 'linear', duration: 50 }
    }
  }
});

export const OpenPose = posed.nav({
  open: { opacity: 1, x: 0 },
  closed: { opacity: 0, x: 150 }
});

export const ItemToAppear = posed.div({
  open: { opacity: 1, y: 0, transition: ({ after }) => ({ delay: after }) },
  closed: { opacity: 0, y: 20 }
});
